import React, { useEffect } from 'react'

const SocialAside=()=>{
  useEffect(()=>{
    document.querySelector('.social-aside').classList.add('carged')
  },[])
  return (
    <aside className="social-aside">
      <div className="social-aside-item">
        <a target='_blank' rel='noreferrer' href='https://www.facebook.com/tuestilo.p'><img src="/icons/aside-facebook.svg" alt="facebook"/></a>
      </div>
      <div className="social-aside-item">
        <a target='_blank' rel='noreferrer' href="https://www.instagram.com/yourstyle_per/"><img src="/icons/aside-instagram.svg" alt="instagram"/></a>
      </div>
      <div className="social-aside-item">
        <a target='_blank' rel='noreferrer' href="https://api.whatsapp.com/send?phone=51932391656"><img src="/icons/aside-whatsapp.svg" alt="whatsapp"/></a>
      </div>
    </aside>
  )
}

export default SocialAside
